export const FEATURE_TOGGLES = {
  /**
   * Controls visibility of the homepage testimonials ("Kundeudtalelser") section.
   * When false: testimonials and related structured data are hidden.
   * When true: testimonials are displayed on the homepage.
   */
  HOMEPAGE_TESTIMONIALS: true,

  /**
   * Controls visibility of pricing on treatment cards in the treatments grid.
   * When false: prices are hidden on cards (but still visible on detail pages).
   * When true: price badges are displayed on each treatment card.
   */
  SHOW_TREATMENT_CARD_PRICING: true,
} as const;

// Type-safe helper to check if a feature is enabled
export const isFeatureEnabled = (feature: keyof typeof FEATURE_TOGGLES): boolean => {
  return FEATURE_TOGGLES[feature];
};